
export function isCustomFormula(formulaStr) {
  // COALESCE is used as a No operation operator.
  // On save custom formula is wrapped within COALESCE formula, so we can uniquely identify if a formula is custom.
  // It shouldn't impact the outcome of the formula, none of the other formula as expected to start with COALESCE
  return formulaStr.startsWith('COALESCE') || formulaStr.startsWith('CONTEXT(COALESCE');
}
